import React from "react";
import PropTypes from "prop-types";

var IncludedIcon = function IncludedIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#387C2B" : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    "aria-hidden": "true",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9062 12C14.4688 14.5 11.8438 16 9 16ZM12.5312 6.53125H12.5C12.8125 6.25 12.8125 5.78125 12.5 5.46875C12.2188 5.1875 11.75 5.1875 11.4688 5.46875L8 8.96875L6.53125 7.5C6.21875 7.1875 5.75 7.1875 5.46875 7.5C5.15625 7.78125 5.15625 8.25 5.46875 8.53125L7.46875 10.5312C7.75 10.8438 8.21875 10.8438 8.53125 10.5312L12.5312 6.53125Z",
    fill: color
  }));
};

IncludedIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string
};
IncludedIcon.defaultProps = {
  width: 18,
  height: 16
};
export default IncludedIcon;